(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["z13ihi-product-card-swatches"] && !Shopify.designMode) return;
  try {
    document.addEventListener('mouseover', function(event) {
    const swatch = event.target.closest('[data-swatch-image]');
    if (!swatch) return;

    const card = swatch.closest('.z13ihi-product-card');
    if (!card) return;

    const primaryImg = card.querySelector('.z13ihi-product-card__primary img');
    if (!primaryImg) return;

    const newSrc = swatch.getAttribute('data-swatch-image');
    if (newSrc) {
      primaryImg.setAttribute('src', newSrc);
      primaryImg.setAttribute('srcset', '');
    }

    const swatches = card.querySelectorAll('.z13ihi-card-swatches__swatch');
    swatches.forEach(function(s) { s.classList.remove('z13ihi-card-swatches__swatch--active'); });
    swatch.classList.add('z13ihi-card-swatches__swatch--active');
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["z13ihi-toast"] && !Shopify.designMode) return;
  try {
    class Z13ihiToast extends HTMLElement {
    connectedCallback() {
      this.messageEl = this.querySelector('[data-ref="toast-message"]');
      this.closeBtn = this.querySelector('[data-ref="toast-close"]');
      this.timeout = null;

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.hide());
      }

      /* Global API */
      window.Z13ihiToast = {
        show: (msg, type, duration) => this.show(msg, type, duration),
        hide: () => this.hide()
      };
    }

    show(msg, type, duration) {
      if (!this.messageEl) return;
      var ms = duration || 4000;
      this.messageEl.textContent = msg;
      this.style.setProperty('--toast-duration', ms + 'ms');
      this.className = 'z13ihi-toast z13ihi-toast--visible';
      if (type) this.classList.add('z13ihi-toast--' + type);

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => this.hide(), ms);
    }

    hide() {
      this.classList.remove('z13ihi-toast--visible');
      clearTimeout(this.timeout);
    }
  }

  if (!customElements.get('z13ihi-toast')) {
    customElements.define('z13ihi-toast', Z13ihiToast);
  }
  } catch(e) { console.error(e); }
})();

})();
